import {
    BRAND_CLIENT_TOKEN_DATA
} from "../constant/ActionType";

export default function GetAllBrandCLientDataToekns(state = {
    getbrandclienttokens: [],
    statuscode: null,
}, action) {
    switch (action.type) {
        case BRAND_CLIENT_TOKEN_DATA:
            return {
                ...state,
                getbrandclienttokens: action?.data,
            };

        default:
    }

    return state;
}